import PageHeader from "@/components/layout/PageHeader";
import Gallery from "@/components/home/Gallery";

export default function GalleryPage() {
  return (
    <>
      <PageHeader
        eyebrow="Gallery"
        title="A look at our counter and services."
        subtitle="Placeholder images — please share original photos of your office, signboard, staff and counter, and we'll swap them in."
      />
      <Gallery full />
    </>
  );
}
